import React from "react";
import {Row, Button} from "react-bootstrap";
import {translate} from "../../i18n/translate.js";
import LoginInputField from "../login/LoginInputField";
import {isEmptyString} from "../../common/utils";
import {URLs} from "../../common/constants";

class LoginChangePassword extends React.Component {
    state = {
        password: '',
        newPassword: '',
        retypedPassword: ''
    };

    handleFieldChange = (isValid, fieldName, value, errorFieldName, error) => {
        let invalid;
        if(!isValid) {
            invalid = error;
        } else {
            invalid = undefined;
        }
        this.state[errorFieldName] = invalid;
        if(value !== undefined) {
            this.state[fieldName] = value;
        }
        this.setState(this.state);
    };

    handleChangePassword = (value) => {
        this.setState({password: value});
    };

    handleChangeNewPassword = (value) => {
        this.setState({newPassword: value});
    };

    handleChangeRetypedPassword = (value) => {
        this.setState({retypedPassword: value});
    };

    validateInputs = () => {
        let isValid = true;
        let errorMessage = '';
        const password = this.state.password;
        if(isEmptyString(password)) {
            isValid = false;
            errorMessage = 'Please enter your old password';
        }
        this.handleFieldChange(isValid, "password", password, "invalidPassword",errorMessage);
        const newPassword = this.state.newPassword;
        if(isEmptyString(newPassword)) {
            isValid = false;
            errorMessage = 'Please enter your new password';
        }
        else if(newPassword.length < 6) {
            isValid = false;
            errorMessage = 'Your password must be at least 6 characters long';
        } else if(newPassword === this.state.password) {
            isValid = false;
            errorMessage = 'You cannot use your old password';
        }
        this.handleFieldChange(isValid, "newPassword", newPassword, "invalidNewPassword",errorMessage);
        let retypedPassword = this.state.retypedPassword;
        let newPasswordValidation = retypedPassword === newPassword;
        if(isEmptyString(retypedPassword)) {
            newPasswordValidation = false;
            errorMessage = 'Please retype new password';
            this.handleFieldChange(newPasswordValidation, 'retypedPassword', retypedPassword, 'invalidRetypedPassword', errorMessage);
        } else {
            this.handleFieldChange(newPasswordValidation, 'retypedPassword', retypedPassword, 'invalidRetypedPassword', 'The password does not match');
        }
        return isValid && newPasswordValidation;
    };

    changeClicked = () => {
        if (this.validateInputs()) {
            this.props.changePassword(this.props.email, this.state.password,
                this.state.newPassword, true);
        }
    };

    render() {
        let className = "border-container";
        if(URLs.JOIN === this.props.flowType) {
            className += " border-container-join";
        }
        return (<div className={className}>
            <fieldset className="inner-container reset-password-container" disabled={this.props.showLoading}>
                <div className="change-password-title">{translate('Your password is a temporary one. Please change your password now.')}</div>
                <div className="form-container container-fluid">
                    <LoginInputField id="oldPassword" type="password" value={this.state.password} label="password" placeholder="Old Password"
                                     error={this.state.invalidPassword} update={this.handleChangePassword} ref="password" fieldName="password"/>
                    <LoginInputField id="newPassword" type="password" value={this.state.newPassword} label="password" placeholder="New Password"
                                     error={this.state.invalidNewPassword} update={this.handleChangeNewPassword} ref="newPassword" fieldName="newPassword"/>
                    <LoginInputField id="passwordAgain" type="password" value={this.state.retypedPassword} label="password" placeholder="Password Again"
                                     error={this.state.invalidRetypedPassword} update={this.handleChangeRetypedPassword} ref="retypedPassword" fieldName="retypedPassword"/>
                    <Row className="email-log-in">
                        <Button bsStyle="primary" className={"button email-login-button" + (this.props.showLoading ? " loading" : "")} id="btnChange" onClick={this.changeClicked}>
                            <div className="btn-email-text">{translate('Change')}</div>
                        </Button>
                    </Row>
                </div>
            </fieldset>
        </div>)
    }
}

export default LoginChangePassword;


// WEBPACK FOOTER //
// ./src/components/login/LoginChangePassword.js